export function useLocation() {
    function normalizeLocation(input: any) {
        if (!input) return '';
        if (Array.isArray(input)) return input;
        if (typeof input === 'string') return input.includes(':') ? [input] : [`region:${input}`];

        if (typeof input === 'object') {
            // is for: { entity, label, value: 'entity:id' }
            if (typeof (input as any).value === 'string' && (input as any).value.includes(':')) {
                return [(input as any).value];
            }
            const entity =
                (input as any).entity ||
                (input as any).type ||
                ((input as any).region ? 'region' : (input as any).country ? 'country' : (input as any).city ? 'city' : 'region');
            const id =
                (input as any).id ||
                (input as any).region?.id ||
                (input as any).city?.id ||
                (input as any).country?.id;
            if (id) return [`${entity}:${id}`];
        }
        return '';
    }

    return {
        normalizeLocation
    };
}
